<div class="app-page">
  <!-- Header -->
  <div class="app-page-header">
    <div class="flex items-center justify-between">
      <div>
        <h1 class="section-title">{{ pageTitle }}</h1>
        <p class="section-subtitle">
          {{ isEditMode() ? 'Modifica la información del usuario' : 'Completa los datos para crear un nuevo usuario' }}
        </p>
      </div>
      <div class="flex gap-2">
        <button 
          pButton 
          type="button"
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-outlined"
          (click)="onCancel()"
          [disabled]="loading()">
        </button>
        <button 
          pButton 
          type="button"
          [label]="isEditMode() ? 'Guardar Cambios' : 'Crear Usuario'"
          [icon]="isEditMode() ? 'pi pi-check' : 'pi pi-plus'"
          class="p-button"
          (click)="onSubmit()"
          [disabled]="loading() || usuarioForm.invalid"
          [loading]="loading()">
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="app-page-content">
    <form [formGroup]="usuarioForm" (ngSubmit)="onSubmit()">
      <div class="grid grid-cols-1 gap-6 xl:grid-cols-2">

      <!-- Columna Izquierda -->
      <div class="space-y-6">

        <!-- Información Personal -->
        <app-component-card title="Información Personal">
          <div class="space-y-6">
            <div>
              <app-label for="email">Email *</app-label>
              <input pInputText id="email" formControlName="email" type="email" placeholder="usuario@ejemplo.com"
                class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary"
                [class.border-red-500]="usuarioForm.get('email')?.invalid && usuarioForm.get('email')?.touched" />
              @if (usuarioForm.get('email')?.invalid && usuarioForm.get('email')?.touched) {
              <small class="text-red-500 text-sm mt-1 block">
                Email es requerido y debe ser válido
              </small>
              }
            </div>

            <div>
              <app-label for="nombre">Nombre *</app-label>
              <input pInputText id="nombre" formControlName="nombre" type="text" placeholder="Juan"
                class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary"
                [class.border-red-500]="usuarioForm.get('nombre')?.invalid && usuarioForm.get('nombre')?.touched" />
              @if (usuarioForm.get('nombre')?.invalid && usuarioForm.get('nombre')?.touched) {
              <small class="text-red-500 text-sm mt-1 block">
                Nombre es requerido
              </small>
              }
            </div>

            <div>
              <app-label for="apellido">Apellido *</app-label>
              <input pInputText id="apellido" formControlName="apellido" type="text" placeholder="Pérez"
                class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary"
                [class.border-red-500]="usuarioForm.get('apellido')?.invalid && usuarioForm.get('apellido')?.touched" />
              @if (usuarioForm.get('apellido')?.invalid && usuarioForm.get('apellido')?.touched) {
              <small class="text-red-500 text-sm mt-1 block">
                Apellido es requerido
              </small>
              }
            </div>

            <div>
              <app-label for="phone">Teléfono</app-label>
              <input pInputText id="phone" formControlName="phone" type="tel" placeholder="+54 11 1234-5678"
                class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary" />
            </div>
          </div>
        </app-component-card>

        <!-- Seguridad -->
        @if (!isEditMode()) {
        <app-component-card title="Seguridad">
          <div class="space-y-6">
            <div>
              <app-label for="password">Contraseña *</app-label>
              <div class="relative">
                <input pInputText id="password" formControlName="password" [type]="showPassword() ? 'text' : 'password'"
                  placeholder="••••••••"
                  class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 pr-12 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary" />
                <button type="button" (click)="togglePasswordVisibility('password')"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                  <i [class]="showPassword() ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
                </button>
              </div>
            </div>

            <div>
              <app-label for="confirmPassword">Confirmar Contraseña *</app-label>
              <div class="relative">
                <input pInputText id="confirmPassword" formControlName="confirmPassword"
                  [type]="showConfirmPassword() ? 'text' : 'password'" placeholder="••••••••"
                  class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 pr-12 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary" />
                <button type="button" (click)="togglePasswordVisibility('confirmPassword')"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                  <i [class]="showConfirmPassword() ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
                </button>
              </div>
            </div>
          </div>
        </app-component-card>
        }
      </div>

      <!-- Columna Derecha -->
      <div class="space-y-6">

        <!-- Roles y Permisos -->
        <app-component-card title="Roles y Permisos">
          <div class="space-y-6">
            <div>
              <app-label for="roles">Roles *</app-label>
              <p-multiSelect formControlName="roles" [options]="rolesOptions" optionLabel="label" optionValue="value"
                placeholder="Seleccione roles" [showToggleAll]="true" [disabled]="!canEditRoles()" styleClass="w-full"
                class="w-full [&_.p-multiselect]:w-full [&_.p-multiselect]:rounded-lg [&_.p-multiselect]:border [&_.p-multiselect]:border-stroke [&_.p-multiselect]:bg-transparent [&_.p-multiselect]:px-5 [&_.p-multiselect]:py-3 [&_.p-multiselect]:text-dark [&_.p-multiselect]:outline-none [&_.p-multiselect]:transition dark:[&_.p-multiselect]:border-dark-3 dark:[&_.p-multiselect]:bg-dark-2 dark:[&_.p-multiselect]:text-white">
              </p-multiSelect>
              @if (!canEditRoles()) {
              <small class="text-blue-600 text-xs mt-1 block">
                Solo administradores pueden modificar roles
              </small>
              }
              @if (usuarioForm.get('roles')?.invalid && usuarioForm.get('roles')?.touched) {
              <small class="text-red-500 text-sm mt-1 block">
                Debe seleccionar al menos un rol
              </small>
              }
            </div>

            <div class="rounded-lg border border-stroke bg-gray-1 p-4 dark:border-dark-3 dark:bg-dark-2">
              <h4 class="mb-3 text-sm font-medium text-dark dark:text-white">Roles Disponibles</h4>
              <ul class="space-y-2 text-sm text-gray-600 dark:text-gray-400">
                <li class="flex items-center gap-2">
                  <span class="inline-flex h-2 w-2 rounded-full bg-blue-500"></span>
                  <strong>Agente de Publicidad:</strong> Usuario con permisos para gestionar órdenes de publicidad
                </li>
                <li class="flex items-center gap-2">
                  <span class="inline-flex h-2 w-2 rounded-full bg-purple-500"></span>
                  <strong>Admin de Publicidad:</strong> Usuario con permisos para gestionar meta variables de publicidad
                </li>
                <li class="flex items-center gap-2">
                  <span class="inline-flex h-2 w-2 rounded-full bg-green-500"></span>
                  <strong>Compaginador:</strong> Usuario con permisos para gestionar tandas, exportación y facturación
                </li>
                <li class="flex items-center gap-2">
                  <span class="inline-flex h-2 w-2 rounded-full bg-yellow-500"></span>
                  <strong>Agente de Facturación:</strong> Usuario con permisos para realizar la facturación
                </li>
                <li class="flex items-center gap-2">
                  <span class="inline-flex h-2 w-2 rounded-full bg-orange-500"></span>
                  <strong>Facturación Auditoría:</strong> Usuario con permisos para consultar datos de la facturación. Usado para auditoría UNL
                </li>
                <li class="flex items-center gap-2">
                  <span class="inline-flex h-2 w-2 rounded-full bg-red-500"></span>
                  <strong>Super Admin:</strong> Role destinado a gestión informática
                </li>
              </ul>
            </div>
          </div>
        </app-component-card>

        <!-- Estado -->
        <app-component-card title="Estado del Usuario">
          <div class="space-y-4">
            <div
              class="flex items-center justify-between rounded-lg border border-stroke bg-white p-4 dark:border-dark-3 dark:bg-dark-2">
              <div class="flex-1">
                <h4 class="text-sm font-medium text-dark dark:text-white">Usuario Activo</h4>
                <p class="mt-1 text-xs text-gray-600 dark:text-gray-400">
                  Cuando está desactivado, el usuario no podrá acceder al sistema
                </p>
              </div>
              <p-toggleSwitch formControlName="enabled" class="ml-4"></p-toggleSwitch>
            </div>

            <div class="rounded-lg bg-blue-50 p-4 dark:bg-blue-900/20">
              <div class="flex items-start gap-3">
                <svg class="mt-0.5 h-5 w-5 flex-shrink-0 text-blue-600 dark:text-blue-400" fill="none"
                  viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div class="flex-1">
                  <h5 class="text-sm font-medium text-blue-900 dark:text-blue-300">Información</h5>
                  <p class="mt-1 text-xs text-blue-700 dark:text-blue-400">
                    Los cambios se aplicarán inmediatamente. El usuario será notificado por email.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </app-component-card>
      </div>
      </div>
    </form>

    <!-- Sección de Cambio de Contraseña (solo en modo edición) -->
    @if (isEditMode()) {
    <div class="mt-6">
    <app-component-card title="Cambiar Contraseña">
      <div class="mb-4">
        <p class="text-sm text-gray-600 dark:text-gray-400">
          El usuario puede cambiar su contraseña proporcionando la contraseña actual
        </p>
      </div>

      <form [formGroup]="formCambioPassword" (ngSubmit)="cambiarClaveUsuario()">
        <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
          <div>
            <app-label htmlFor="oldPassword" [required]="true">Contraseña Actual</app-label>
            <div class="relative">
              <input pInputText id="oldPassword" formControlName="oldPassword"
                [type]="showOldPassword() ? 'text' : 'password'" placeholder="••••••••"
                class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 pr-12 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary"
                [class.border-red-500]="formCambioPassword.get('oldPassword')?.invalid && formCambioPassword.get('oldPassword')?.touched" />
              <button type="button" (click)="togglePasswordVisibility('oldPassword')"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                <i [class]="showOldPassword() ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
              </button>
            </div>
            @if (formCambioPassword.get('oldPassword')?.invalid && formCambioPassword.get('oldPassword')?.touched) {
            <small class="text-red-500 text-sm mt-1 block">
              Contraseña actual es requerida
            </small>
            }
          </div>

          <div>
            <app-label htmlFor="newPassword" [required]="true">Nueva Contraseña</app-label>
            <div class="relative">
              <input pInputText id="newPassword" formControlName="newPassword"
                [type]="showNewPassword() ? 'text' : 'password'" placeholder="••••••••"
                class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 pr-12 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary"
                [class.border-red-500]="formCambioPassword.get('newPassword')?.invalid && formCambioPassword.get('newPassword')?.touched" />
              <button type="button" (click)="togglePasswordVisibility('newPassword')"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                <i [class]="showNewPassword() ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
              </button>
            </div>
            @if (formCambioPassword.get('newPassword')?.invalid && formCambioPassword.get('newPassword')?.touched) {
            <small class="text-red-500 text-sm mt-1 block">
              @if (formCambioPassword.get('newPassword')?.errors?.['required']) {
              Nueva contraseña es requerida
              }
              @if (formCambioPassword.get('newPassword')?.errors?.['minlength']) {
              Debe tener al menos 7 caracteres
              }
            </small>
            }
          </div>

          <div>
            <app-label htmlFor="newRetypedPassword" [required]="true">Confirmar Nueva Contraseña</app-label>
            <div class="relative">
              <input pInputText id="newRetypedPassword" formControlName="newRetypedPassword"
                [type]="showNewRetypedPassword() ? 'text' : 'password'" placeholder="••••••••"
                class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 pr-12 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary"
                [class.border-red-500]="formCambioPassword.get('newRetypedPassword')?.invalid && formCambioPassword.get('newRetypedPassword')?.touched" />
              <button type="button" (click)="togglePasswordVisibility('newRetypedPassword')"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                <i [class]="showNewRetypedPassword() ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
              </button>
            </div>
            @if (formCambioPassword.get('newRetypedPassword')?.invalid &&
            formCambioPassword.get('newRetypedPassword')?.touched) {
            <small class="text-red-500 text-sm mt-1 block">
              Debe confirmar la nueva contraseña
            </small>
            }
          </div>
        </div>

        @if (formCambioPassword.errors?.['passwordsMismatch'] && formCambioPassword.dirty) {
        <div class="mt-4 rounded-lg bg-red-50 p-4 dark:bg-red-900/20">
          <div class="flex items-start gap-3">
            <svg class="mt-0.5 h-5 w-5 flex-shrink-0 text-red-600 dark:text-red-400" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
            <p class="text-sm text-red-700 dark:text-red-400">
              Las contraseñas no coinciden
            </p>
          </div>
        </div>
        }

        <div class="mt-6 flex justify-end">
          <button pButton type="submit" label="Cambiar Contraseña" icon="pi pi-key" [loading]="loading()"
            [disabled]="formCambioPassword.invalid || loading()"></button>
        </div>
      </form>
    </app-component-card>
  </div>

    }

    <!-- Sección de Forzar Contraseña (solo administradores) -->
    @if (isEditMode() && isAdmin()) {
    <div class="mt-6">
    <app-component-card title="Forzar Cambio de Contraseña">
      <div class="mb-4 rounded-lg bg-brand-50 p-4 dark:bg-brand-900/20">
        <div class="flex items-start gap-3">
          <svg class="mt-0.5 h-5 w-5 flex-shrink-0 text-brand-600 dark:text-brand-400" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <div class="flex-1">
            <h5 class="text-sm font-medium text-brand-900 dark:text-brand-300">Solo Administradores</h5>
            <p class="mt-1 text-xs text-brand-700 dark:text-brand-400">
              Esta función permite cambiar la contraseña sin conocer la actual. Usar con precaución.
            </p>
          </div>
        </div>
      </div>

      <form [formGroup]="formForzarPassword" (ngSubmit)="forzarCambioPassword()">
        <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <app-label htmlFor="forceNewPassword" [required]="true">Nueva Contraseña</app-label>
            <div class="relative">
              <input pInputText id="forceNewPassword" formControlName="forceNewPassword"
                [type]="showForceNewPassword() ? 'text' : 'password'" placeholder="••••••••"
                class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 pr-12 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary"
                [class.border-red-500]="formForzarPassword.get('forceNewPassword')?.invalid && formForzarPassword.get('forceNewPassword')?.touched" />
              <button type="button" (click)="togglePasswordVisibility('forceNewPassword')"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                <i [class]="showForceNewPassword() ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
              </button>
            </div>
            @if (formForzarPassword.get('forceNewPassword')?.invalid &&
            formForzarPassword.get('forceNewPassword')?.touched) {
            <small class="text-red-500 text-sm mt-1 block">
              @if (formForzarPassword.get('forceNewPassword')?.errors?.['required']) {
              Nueva contraseña es requerida
              }
              @if (formForzarPassword.get('forceNewPassword')?.errors?.['minlength']) {
              Debe tener al menos 7 caracteres
              }
            </small>
            }
          </div>

          <div>
            <app-label htmlFor="forceRetypedPassword" [required]="true">Confirmar Nueva Contraseña</app-label>
            <div class="relative">
              <input pInputText id="forceRetypedPassword" formControlName="forceRetypedPassword"
                [type]="showForceRetypedPassword() ? 'text' : 'password'" placeholder="••••••••"
                class="w-full rounded-lg border border-stroke bg-transparent px-5 py-3 pr-12 text-dark outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-gray-2 dark:border-dark-3 dark:bg-dark-2 dark:text-white dark:focus:border-primary"
                [class.border-red-500]="formForzarPassword.get('forceRetypedPassword')?.invalid && formForzarPassword.get('forceRetypedPassword')?.touched" />
              <button type="button" (click)="togglePasswordVisibility('forceRetypedPassword')"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                <i [class]="showForceRetypedPassword() ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
              </button>
            </div>
            @if (formForzarPassword.get('forceRetypedPassword')?.invalid &&
            formForzarPassword.get('forceRetypedPassword')?.touched) {
            <small class="text-red-500 text-sm mt-1 block">
              Debe confirmar la nueva contraseña
            </small>
            }
          </div>
        </div>

        @if (formForzarPassword.errors?.['passwordsMismatch'] && formForzarPassword.dirty) {
        <div class="mt-4 rounded-lg bg-red-50 p-4 dark:bg-red-900/20">
          <div class="flex items-start gap-3">
            <svg class="mt-0.5 h-5 w-5 flex-shrink-0 text-red-600 dark:text-red-400" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
            <p class="text-sm text-red-700 dark:text-red-400">
              Las contraseñas no coinciden
            </p>
          </div>
        </div>
        }

        <div class="mt-6 flex justify-end">
          <button pButton type="submit" label="Forzar Cambio de Contraseña" icon="pi pi-shield" class="p-button-warning"
            [loading]="loading()" [disabled]="formForzarPassword.invalid || loading()"></button>
        </div>
      </form>
    </app-component-card>
    </div>
    }
  </div>
</div>